import React, { Component } from 'react';
import TransLink from '@common/TransLink';

import { Container } from '@components/global';
import {
  Nav,
  NavItem,
  Brand,
  StyledContainer,
  NavListWrapper,
  MobileMenu,
  Mobile,
} from './style';

import LogoSrc from '@static/logo.png';
import { ReactComponent as MenuIcon } from '@static/icons/menu.svg';
import { ReactComponent as CartIcon } from '@static/icons/cart.svg';

const NAV_ITEMS = [
  {
    name: 'About Us',
    to: '/about',
  },
  {
    name: `‹ Go back home`,
    to: '/',
  },
];

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.navItems = [NAV_ITEMS[this.props.location.pathname === '/' ? 0 : 1]];

    this.state = {
      mobileMenuOpen: false,
    };
  }

  toggleMobileMenu = () => {
    this.setState(prevState => ({ mobileMenuOpen: !prevState.mobileMenuOpen }));
  };

  closeMobileMenu = () => {
    if (this.state.mobileMenuOpen) {
      this.setState({ mobileMenuOpen: false });
    }
  };

  getNavAnchorLink = ({ name, to }) => (
    <TransLink to={to} onClick={this.closeMobileMenu}>
      {name}
    </TransLink>
  );

  getNavList = ({ mobile = false }) => (
    <NavListWrapper mobile={mobile}>
      <ul>
        {this.navItems.map(navItem =>
          navItem.name !== 'Cart' || mobile ? (
            <NavItem key={navItem}>{this.getNavAnchorLink(navItem)}</NavItem>
          ) : (
            <NavItem key={navItem}>
              <a
                href={`#${navItem.toLowerCase()}`}
                onClick={this.closeMobileMenu}
              >
                <CartIcon
                  style={{ width: 24, height: 24, margin: '0 0.5rem' }}
                />
              </a>
            </NavItem>
          )
        )}
      </ul>
    </NavListWrapper>
  );

  render() {
    const { mobileMenuOpen } = this.state;

    return (
      <Nav {...this.props}>
        <StyledContainer>
          <Brand as={TransLink} to={`/`}>
            <img src={LogoSrc} alt="illuvia" />
          </Brand>
          <Mobile>
            <button onClick={this.toggleMobileMenu}>
              <MenuIcon />
            </button>
          </Mobile>

          <Mobile hide>{this.getNavList({})}</Mobile>
        </StyledContainer>
        <Mobile>
          {mobileMenuOpen && (
            <MobileMenu>
              <Container>{this.getNavList({ mobile: true })}</Container>
            </MobileMenu>
          )}
        </Mobile>
      </Nav>
    );
  }
}

export default Navbar;
